<app-banner></app-banner>

<ng-container >

  <div class="slider-container d-flex">
    
    <div class="slider relative ">
      <div class="end-gradient left-gradient"></div>
      <div class="slide-track align-items-center" [ngClass]="{'hide-scrollbar': isMobile}">
        <div class="slide align-items-center d-flex pointer" *ngFor="let brand of brandTickers">
          <img class="sliderImg" [src]="brand.logo" [ngStyle]="isMobile ? brand.style?.mobile : brand.style?.desktop" (click)="redirectToDetails(brand.merchantId, brand.name)" />
        </div>
      </div>
      <div class="end-gradient right-gradient"></div>
    </div>
  </div>
</ng-container>

<!-- <section class="homepage-communication-banner container relative">
  <div class="banner-img relative">
    <img class="img-fluid d-none d-sm-block" [src]="'assets/banners/homepage-communication/homepage-communication-web.png'" alt="banner" width="100%">
    <img class="img-fluid d-block d-sm-none" [src]="'assets/banners/homepage-communication/homepage-communication-mobile.png'" alt="banner" width="100%">
  </div>
  <section class="absolute d-flex flex-column communication-text justify-content-center h100">
    <span class="fnt-20 f600 text-primary mar-bot-8 text-heading">With Mastercard Easy Savings Specials, <br/>you can unlock offers on Business essentials.</span>
    <span class="fnt-18 f600 text-sub-heading">Explore offers from top global brands that can be unlocked today with your Business Mastercard.</span>
  </section>
</section> -->

<!-- <section *ngIf="bannerItems.length"
  class="homepage-communication-banner w100 d-flex align-items-center justify-content-center relative pad-top-20">
  <ngu-carousel class="carousel-container d-flex align-center" #bannerCarousel [inputs]="bannerTile"
    [dataSource]="filteredBanners">
    <ngu-tile *nguCarouselDef="let banner; let ind = index" class="d-flex align-center justify-center">
      <a href="{{ banner?.attributes?.banner_url }}">
        <img class="banner-image" src="{{ banner?.attributes?.banner_image }}" alt="offers announcement banner" />
      </a>
    </ngu-tile> -->

<!-- <section *ngIf="filteredBanners.length > 0 && !bannerLoading" class="homepage-communication-banner container w100 d-flex align-items-center justify-content-center relative pad-top-20 pad-bot-20 mb-3">
  <carousel class="slide-animated">
    <slide  *ngFor = "let banner of filteredBanners">
      <a href="{{ banner?.attributes?.banner_url }}">
      <img class="banner-image" src={{banner?.attributes?.banner_image}} alt="offers announcement banner">
      </a>
    </slide>
  </carousel>
  
</section> -->

<app-tag-based-offers class="d-flex flex-column" [ngClass]="{'mx-5': !isMobile}"></app-tag-based-offers>

<section i18n *ngIf="!isCategoryLoading && categories.length == 0"
  class="pad-top-50 mar-top-50 pad-bot-50 fnt-24 text-center no-offers f500">No offers found!</section>

<section class="container-flex">

  <div class="d-flex flex-column gap-2 categories-container" [ngClass]="isMobile ? 'p-3' : 'p-5'">

    <span i18n class="text-white" [ngClass]="isMobile ? 'fnt-20' : 'fnt-32 mx-5'">Categories</span>

    <div *ngIf="isCategoryLoading; else showCategories" class="d-flex flex-wrap" [ngClass]="{'mx-5': !isMobile}">
      <div class="category-tag-loader me-3 mb-2" *ngFor="let i of [1,2,3,4,5]">
        <div class="timeline-item">
          <div class="animated-background"></div>
        </div>
      </div>
    </div>

      <ng-template #showCategories>
        <div class="d-flex flex-wrap text-white mt-2" [ngClass]="{'mx-5': !isMobile}">
          <div *ngFor="let category of categories" class="category-tag px-3 py-2 me-2 mt-2 pointer d-flex align-items-center" (click)="handleCategorySelection(category)" [ngClass]="{'selected': category.attributes.code === selectedCategory?.attributes?.code}">
          <pv-svg-icon class="me-2" styleClass="category-icon my-auto d-flex" *ngIf="appConstants?.categories?.[category?.attributes?.code]?.img ?? category?.attributes?.logo_url" [srcUrl]="appConstants?.categories?.[category?.attributes?.code]?.img ?? category?.attributes?.logo_url"></pv-svg-icon>
            {{category.attributes.name}}
          </div>
        </div>
      </ng-template>
  </div>

  <div [ngClass]="{'mx-5': !isMobile}" class="d-flex flex-column mb-4">
    <div *ngIf="isCategoryLoading || isLoadingOffers; else showOffers">
      <section class="pad-bot-40 pad-top-25 category-block mx-5">
        <app-card-loader [count]="4" [perLine]="isMobile ? 2 : 4"></app-card-loader>
      </section>
    </div>
  
    <ng-template #showOffers>
      <div class="row offer-row" [ngClass]="isMobile ? 'mt-3 mx-2' : 'mt-5'">
        <app-offers-card [isMobile] = "isMobile" class="col-sm-3 offer-card" [offer]="offer" *ngFor="let offer of offers" clickPosition="all-offers" [offerType]="selectedCategory.attributes.code" siteSection = "homepage" ></app-offers-card>
      </div>
      <button i18n class="show-more-cta mx-auto btn fnt-14 f600" *ngIf="selectedCategory" (click)="redirectToListingPage()">Show more</button>
    </ng-template>
  </div>


</section>
<section class="relative pad-top-20 priceless-sec">
  <div class="priceless-banner">
    <div class="container h100 flex align-center">
      <div class="text-container d-flex flex-column">
        <div i18n class="f500 mar-bot-8 w100" [ngClass]="{
          'fnt-20': isMobile && isReduceFontSize,
          'fnt-28': !isMobile || !isReduceFontSize
        }">Find more offers to save on your business travels</div>
        <a class="ml-auto mb-1" href="https://www.priceless.com/easy-savings?ac=easysavings" target="_blank"
          rel="noreferrer noopener"><button (click)="analyticsLinkData('more_savings')" i18n
            class="border-0 more-btn brand-btn fnt-12 pad-15 pad-top-8 pad-bot-9">More savings</button></a>
      </div>
    </div>
  </div>
</section>